// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","701":"homeM"}[chunkId] + "." + {"177":"31172631","701":"b8bf0e07"}[chunkId] + ".css";
};